import React, { useRef, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { encryptData } from "../../UI/crypto";
import config from "../../config";
import { decryptURL } from "../../UI/URLencryption";
function Sidebar11() {
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const contentRef1 = useRef(null);
  const contentRef2 = useRef(null);
  const [loading, setLoading] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [downloadfilename, setDownloadfilename] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const toggleDropdown1 = () => {
    setIsOpen1(!isOpen1);
  };

  const toggleDropdown2 = () => {
    setIsOpen2(!isOpen2);
  };

  useEffect(() => {
    if (contentRef1.current) {
      contentRef1.current.style.maxHeight = isOpen1
        ? `${contentRef1.current.scrollHeight}px`
        : "0px";
    }
  }, [isOpen1]);

  useEffect(() => {
    if (contentRef2.current) {
      contentRef2.current.style.maxHeight = isOpen2
        ? `${contentRef2.current.scrollHeight}px`
        : "0px";
    }
  }, [isOpen2]);

  const isAddSchoolActive = [
    "/class-xi-add-student-jac-page",
    "/class-xi-add-student-jac",
    "/class-xi-add-others-student",
    "/class-xi-add-ex-regular-jac",
    "/class-xi-add-ex-regular-info-jac",
    "/class-xi-board-registration",
    "/class-xi-upload-document",
  ].includes(location.pathname);

  const isReportsActive = [
    "/class-xi-total-registration",
    "/class-xi-checklist-generated",
    "/class-xi-generate-challan",
    "/class-xi-challan-status",
    "/class-xi-consolidated-checklist",
  ].includes(location.pathname);

  // const downloadadmit = (stream) => {
  //   const schoolID = sessionStorage.getItem("schoolcode");
  //   const districtid = sessionStorage.getItem("district");
  //   if (!schoolID) {
  //     alert("School ID is missing.");
  //     return;
  //   }

  //   const domain = window.location.origin;
  //   console.log(domain);
  //   const filePath = `${domain}/Admit_cards/${districtid}/${schoolID}/${stream}.pdf`;
  //   console.log(filePath);
  //   const link = document.createElement("a");
  //   link.href = filePath;
  //   link.download = `${stream}.pdf`;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  // const downloadtr = () => {
  //   const domain = window.location.origin;
  //   const classFolder = "class-xi";
  //   const districtId = sessionStorage.getItem("district");
  //   const schoolId = sessionStorage.getItem("schoolCode");

  //   if (!schoolId) {
  //     alert("School ID is missing.");
  //     return;
  //   }
  //   if (!districtId) {
  //     alert("District ID is missing.");
  //     return;
  //   }
  //   const filePath = `${domain}/${classFolder}/${districtId}/${schoolId}.pdf`;
  //   const link = document.createElement("a");
  //   link.href = filePath;
  //   link.download = `Tabulation-Register-${schoolId}.pdf`;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };
  const downloadtr = async () => {
    const fileurl = sessionStorage.getItem("class11TabulationFilelink");
    const distcode = sessionStorage.getItem("district");
    const schoolcode = sessionStorage.getItem("schoolCode");

    if (!fileurl) {
      alert("No Tabulation Register card found");
      return;
    }

    const finalurl = decryptURL(fileurl);
    setDownloadfilename("Tabulation Register")
    try {
      setLoading(true);
      setDownloadProgress(10);

      const res = await fetch(finalurl);
      setDownloadProgress(60);

      const blob = await res.blob();
      setDownloadProgress(90);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Tabulation-Register_11_${schoolcode}.pdf`;
      a.click();

      window.URL.revokeObjectURL(url);

      setDownloadProgress(100);

      setTimeout(() => {
        setLoading(false);
        setDownloadProgress(0);
      }, 300);
    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download");
      setLoading(false);
      setDownloadProgress(0);
    }
  }
  const movetonextd = (e) => {
    e.preventDefault();

    const params = {
      schooL_CODE: sessionStorage.getItem("schoolCode"),
      schooL_NAME: sessionStorage.getItem("schoolname"),
      heaD_MOBILE_NO: sessionStorage.getItem("headMobileNo"),
      emaiL_ADDRESS: sessionStorage.getItem("schoolEmailId"),
      district: sessionStorage.getItem("district"),
      district_name: sessionStorage.getItem("districtname"),
      assistant_master_no: sessionStorage.getItem("assistantteachercontact"),
    };

    console.log("Before Encrypt:", params);

    const encryptedData = encryptData(params, config.SECRET_KEY);
    const encodedData = encodeURIComponent(encryptedData);
    window.open(`${config.IA_LINK}/class-xi?data=${encodedData}`, "_blank");
  };
  const downloadadmit = async (stream) => {
    try {
      let linkKey = "";
      let fileNameStream = "";

      switch (stream) {
        case "ARTS":
          linkKey = "class11admitcardlinkarts";
          fileNameStream = "Arts";
          break;
        case "COMMERCE":
          linkKey = "class11admitcardlinkcommerce";
          fileNameStream = "Commerce";
          break;
        case "SCIENCE":
          linkKey = "class11admitcardlinkscience";
          fileNameStream = "Science";
          break;
        default:
          alert("Invalid stream");
          return;
      }

      const encryptedUrl = sessionStorage.getItem(linkKey);
      const districtCode = sessionStorage.getItem("district");

      if (!encryptedUrl) {
        alert(`No admit card found for ${fileNameStream}`);
        return;
      }

      const finalUrl = decryptURL(encryptedUrl);
      setDownloadfilename("Admit Card")
      setLoading(true);
      setDownloadProgress(0);

      const response = await fetch(finalUrl);

      if (!response.ok) {
        throw new Error("Failed to download PDF");
      }

      const contentLength = response.headers.get("content-length");
      const total = contentLength ? parseInt(contentLength, 10) : 0;

      const reader = response.body.getReader();
      let receivedLength = 0;
      const chunks = [];

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        chunks.push(value);
        receivedLength += value.length;

        if (total) {
          const percent = Math.round((receivedLength / total) * 100);
          setDownloadProgress(percent);
        }
      }

      const blob = new Blob(chunks, { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `Admit_Card_Class_XI_${fileNameStream}_${districtCode}.pdf`;
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      setLoading(false);
      setDownloadProgress(0);
    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download admit card");
      setLoading(false);
      setDownloadProgress(0);
    }
  };
  return (
    <>
      {loading && (
        <div className="download-modal-overlay">
          <div className="download-modal">
            <div className="spinner"></div>

            <h4>Downloading {downloadfilename}</h4>

            <div className="progress-wrapper">
              <div
                className="progress-bar"
                style={{ width: `${downloadProgress}%` }}
              ></div>
            </div>

            <p>{downloadProgress}% completed</p>
          </div>
        </div>
      )}
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <ul className="nav">
          {sessionStorage.getItem("class11profile") === "YES" && (
            <li
              className={`nav-item ${location.pathname === "/class-xi-dashboard" ? "active" : ""
                }`}
            >
              <a
                href="#"
                className="nav-link back-g"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/class-xi-dashboard");
                }}
              >
                <i className="icon-grid menu-icon"></i>
                <span className="menu-title">Dashboard</span>
              </a>
            </li>
          )}
          <li
            className={`nav-item ${location.pathname === "/class-xi-school-profile" ? "active" : ""
              }`}
          >
            <a
              href="#"
              className="nav-link back-g"
              onClick={(e) => {
                e.preventDefault();
                navigate("/class-xi-school-profile");
              }}
            >
              <i className="fa fa-university menu-icon"></i>
              <span className="menu-title">School Profile</span>
            </a>
          </li>

          {/* First Dropdown */}
          {/* {sessionStorage.getItem("class11profile") === "YES" && (
            <li className={`nav-item ${isAddSchoolActive ? "active" : ""}`}>
              <a
                className="nav-link back-g"
                onClick={toggleDropdown1}
                style={{ cursor: "pointer" }}
                aria-expanded={isOpen1}
                aria-controls="auth1"
              >
                <i className="icon-head menu-icon"></i>
                <span className="menu-title">Add Student</span>
                <i className="menu-arrow"></i>
              </a>
              <div id="auth1" ref={contentRef1} className="custom-collapse">
                <ul className="nav flex-column sub-menu sub-green">
                  <li className="nav-item">
                    <a
                      className="nav-link back-g"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-xi-add-student-jac");
                      }}
                    >
                      Add Student (JAC)
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link back-g"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-xi-add-others-student");
                      }}
                      rel="noopener noreferrer"
                    >
                      Add Student (Others)
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link back-g"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-xi-add-ex-regular-jac");
                      }}
                      rel="noopener noreferrer"
                    >
                      Ex-Regular Students
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link back-g"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-xi-board-registration");
                      }}
                      rel="noopener noreferrer"
                    >
                      Before 2011 Registration
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          )} */}
          {sessionStorage.getItem("class11profile") === "YES" && (
            <li className={`nav-item ${isReportsActive ? "active" : ""}`}>
              <a
                className="nav-link back-g"
                onClick={toggleDropdown2}
                style={{ cursor: "pointer" }}
                aria-expanded={isOpen2}
                aria-controls="auth2"
              >
                <i className="fa fa-file menu-icon"></i>
                <span className="menu-title">Reports</span>
                <i className="menu-arrow"></i>
              </a>
              <div id="auth2" ref={contentRef2} className="custom-collapse">
                <ul className="nav flex-column sub-menu sub-green">
                  <li className="nav-item">
                    <a
                      className="nav-link back-g"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-xi-total-registration");
                      }}
                    >
                      Total Registration
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link back-g"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-xi-checklist-generated");
                      }}
                      rel="noopener noreferrer"
                    >
                      Checklist Generated
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link back-g"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-xi-generate-challan");
                      }}
                      rel="noopener noreferrer"
                    >
                      Generate Challan
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link back-g"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-xi-challan-status");
                      }}
                      rel="noopener noreferrer"
                    >
                      Challan Status
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link back-g"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-xi-consolidated-checklist");
                      }}
                      rel="noopener noreferrer"
                    >
                      List of Registered <br></br>Students
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          )}
          {/* {sessionStorage.getItem("class11profile") === "YES" &&
            sessionStorage.getItem("class11admitcardbutton") === "ON" &&
            sessionStorage.getItem("class11artsadmit") === "ON" && (
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    downloadadmit("Arts");
                  }}
                >
                  <i className="fa fa-download menu-icon"></i>
                  <span className="menu-title">Download Admit Card (Arts)</span>
                </a>
              </li>
            )}
          {sessionStorage.getItem("class11profile") === "YES" &&
            sessionStorage.getItem("class11admitcardbutton") === "ON" &&
            sessionStorage.getItem("class11commerceadmit") === "ON" && (
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    downloadadmit("Comm");
                  }}
                >
                  <i className="fa fa-download menu-icon"></i>
                  <span className="menu-title">
                    Download Admit Card (Commerce)
                  </span>
                </a>
              </li>
            )}
          {sessionStorage.getItem("class11profile") === "YES" &&
            sessionStorage.getItem("class11admitcardbutton") === "ON" &&
            sessionStorage.getItem("class11scienceadmit") === "ON" && (
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    downloadadmit("Science");
                  }}
                >
                  <i className="fa fa-download menu-icon"></i>
                  <span className="menu-title">
                    Download Admit Card (Science)
                  </span>
                </a>
              </li>
            )} */}
          {sessionStorage.getItem("correctionstatus11") === "ON" && (
            <li className="nav-item">
              <a
                className="nav-link back-g"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/class-xi-correct-student");
                }}
              >
                <i class="fa fa-check menu-icon"></i>
                <span className="menu-title ">Correct Student Data</span>
              </a>
            </li>
          )}
          {/* {sessionStorage.getItem("class11profile") === "YES" && (
            <li
              className={`nav-item ${location.pathname === "/class-xi-data-not-found" ? "active" : ""
                }`}
            >
              <a
                className="nav-link text-danger back-g"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/class-xi-data-not-found");
                }}
              >
                <i class="fa fa-times menu-icon text-danger"></i>
                <span className="menu-title ">Data Not Found</span>
              </a>
            </li>
          )}
          {sessionStorage.getItem("class11profile") === "YES" && (
            <li
              className={`nav-item ${location.pathname === "/class-xi-data-not-found-list"
                ? "active"
                : ""
                }`}
            >
              <a
                className="nav-link text-danger back-g"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/class-xi-data-not-found-list");
                }}
              >
                <i class="fa fa-list menu-icon text-danger"></i>
                <span className="menu-title " style={{ fontSize: "13px" }}>
                  Status of Data Not Found
                </span>
              </a>
            </li>
          )} */}
          {sessionStorage.getItem("class11admitcardbutton") === "ON" &&
            sessionStorage.getItem("class11admitcardlinkarts") && (
              <li className="nav-item">
                <a
                  className="nav-link back-g"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    downloadadmit("ARTS");
                  }}
                >
                  <i className="fa fa-download menu-icon"></i>
                  <span className="menu-title">Admit Card (Arts)</span>
                </a>
              </li>
            )}
          {sessionStorage.getItem("class11admitcardbutton") === "ON" &&
            sessionStorage.getItem("class11admitcardlinkcommerce") && (
              <li className="nav-item">
                <a
                  className="nav-link back-g"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    downloadadmit("COMMERCE");
                  }}
                >
                  <i className="fa fa-download menu-icon"></i>
                  <span className="menu-title">Admit Card (Commerce)</span>
                </a>
              </li>
            )}
          {sessionStorage.getItem("class11admitcardbutton") === "ON" &&
            sessionStorage.getItem("class11admitcardlinkscience") && (
              <li className="nav-item">
                <a
                  className="nav-link back-g"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    downloadadmit("SCIENCE");
                  }}
                >
                  <i className="fa fa-download menu-icon"></i>
                  <span className="menu-title">Admit Card (Science)</span>
                </a>
              </li>
            )}
          {sessionStorage.getItem("tabulationReg11") === "ON" && sessionStorage.getItem("class11TabulationFilelink") && (
            <li className="nav-item blink-text" style={{ padding: "1px 6px" }}>
              <a
                className="nav-link color btn btn-danger text-white"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  downloadtr();
                }}
                style={{
                  backgroundColor: "#dc3545",
                  padding: "8px 12px",
                  borderRadius: "3px",
                }}
              >
                <i className="fa fa-download menu-icon text-white"></i>
                <span className="menu-title" style={{ fontSize: "12px" }}>
                  TABULATION REGISTER
                </span>
              </a>
            </li>
          )}
          {sessionStorage.getItem("class11IAportal") === "ON" && (
            <li className="nav-item ">
              <a
                className="nav-link  back-g nav-link-ia12 text-success"
                href="#"
                onClick={movetonextd}
              >
                <i className="fa fa-arrow-right menu-icon text-success"></i>
                <span
                  className="menu-title text-success"
                  style={{ fontSize: "13px", fontWeight: "600" }}
                >
                  IA Marks Entry Portal
                </span>
              </a>
            </li>
          )}
        </ul>
      </nav>
    </>
  );
}

export default Sidebar11;
